import React, { FunctionComponent } from 'react';
import { Avatar, Badge, Menu, Icon, Button } from 'antd';
import { NavLink } from 'react-router-dom';
import MenuAvatar from '../MenuAvatar';

const LoginBar: FunctionComponent = () => {
    return (
        <Menu style={{fontWeight: 500}} mode="horizontal" theme="dark">
            <Menu.Item>
                <NavLink to={'/login'} ><Button style={{ fontWeight: 500 }}>
                    LOG IN </Button></NavLink>
            </Menu.Item>
            <Menu.Item>
                <NavLink to={'/register'} >
                    <Button ghost style={{ fontWeight: 500 }}>SIGN UP</Button></NavLink>
            </Menu.Item>
            <Menu.Item>
                <a href="https://vmwealth.myvmgroup.com/contact-us/" target="_blank">CONTACT US</a>
            </Menu.Item>
            <Menu.Item>
                <NavLink to={'/ipo'} >IPO/APO LISTING</NavLink>
            </Menu.Item>
           
        </Menu>
    );
};

export default LoginBar;






